// extracted by mini-css-extract-plugin
export default {"container":"QuestionComponents_container__LNMhK"};